<div class="fund-wrap" *ngIf="fundraisersList?.length">
  <div class="details">
    <span class="title">
      {{isMobile ? 'Your Journey of Change Starts Here with Ray Of Joy' : 'Make a Difference with Ray Of Joy'}}
    </span>
    <span class="desc">
      {{isMobile ? 'Contribute to save lives at risk and in need of urgent funds. Help them win their battle for life. Here are some fundraisers that need your attention.' : 'Contribute to save lives at risk and in need of urgent funds. Help them win their battle for life.'}}
    </span>
  </div>
  <ng-container>
    <ngx-glide [arrowLeftTemplate]="(fundraisersList?.length > 3 && arrowLeftTemplate) || null"
      [arrowRightTemplate]="(fundraisersList?.length > 3 && arrowRightTemplate) || null"
      [showArrows]="fundraisersList?.length > 3" [showBullets]="false" [perView]="isMobile ? 1.5 : 3" [bound]="true" [dragThreshold]="true"
      arrowLeftLabel="" arrowRightLabel="">
      <ng-container *ngFor="let fundraiser of fundraisersList; let i = index">
        <app-fundraiser-card [isExternal]="true" [fundraiser]="fundraiser" theme="v3" [openInNewTab]="true" />
      </ng-container>
    </ngx-glide>
    <ng-template #arrowLeftTemplate>
      <div class="custom-arrow custom-arrow-left">
        <mat-icon class="btn-clr">chevron_left</mat-icon>
      </div>
    </ng-template>
    <ng-template #arrowRightTemplate>
      <div class="custom-arrow custom-arrow-right">
        <mat-icon class="btn-clr">chevron_right</mat-icon>
      </div>
    </ng-template>
  </ng-container>
</div>
<div class="fund-wrap-error" *ngIf="fundraisersList?.length === 0">
  No Campaigns Found
</div>